package com.fireavert.reboot.logic

@kotlinx.serialization.Serializable
data class RebootDeviceRequest(
    val deviceLocator: String? = null
)
